module.exports = __webpack_public_path__ + "static/media/develop.6a743656.svg";